import React, { lazy } from 'react';
import { motion } from 'framer-motion';
const bonuses = [{
  number: '#1',
  title: 'GUÍA PARA ALIVIAR LAS MOLESTIAS DE LOS DIENTES',
  desc: 'Cómo aliviar la fase de la salida de los dientecitos sin sufrimiento.',
  value: '$19.99',
  image: 'https://cdn.magicpatterns.com/uploads/u1RPxGksa5zV4884zqnEgs/BONUS_1.png'
}, {
  number: '#2',
  title: 'GUÍA DEL SUEÑO A TRAVÉS DE LA ALIMENTACIÓN',
  desc: 'Qué alimentos ayudan a que tu bebé duerma mejor — y cuáles lo sabotean sin que te des cuenta.',
  value: '$29.99',
  image: 'https://cdn.magicpatterns.com/uploads/931G1xjgPirjt9dSQzkggy/BONUS_2.png'
}, {
  number: '#3',
  title: 'GUÍA DEL DESTETE SIN SUFRIMIENTO',
  desc: 'El paso a paso para un destete suave, al ritmo de tu bebé.',
  value: '$34.99',
  image: 'https://cdn.magicpatterns.com/uploads/3NrksYzzsSNrsi76fzokpp/BONUS_3.png'
}];
export function Bonuses() {
  return <section className="py-10 md:py-20 px-5 md:px-6 bg-[#FFF1F4]" data-id="element-17">
      <div className="max-w-6xl mx-auto" data-id="element-18">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-8 md:mb-16" data-id="element-19">
          <h2 className="text-3xl md:text-5xl lg:text-6xl font-bold text-[#2D1F1A] tracking-tight" data-id="element-20">
            BONOS <em className="text-[#F9A8B7] not-italic" data-id="element-21">GRATIS</em> (HOY)
          </h2>
          <p className="text-base md:text-xl text-gray-600 mt-2 md:mt-4 italic" data-id="element-22">
            3 guías exclusivas incluidas{' '}
            <span className="not-italic font-bold text-[#F9A8B7]" data-id="element-23">
              sin costo extra
            </span>
          </p>
        </motion.div>
        <div className="grid md:grid-cols-3 gap-5 md:gap-8" data-id="element-24">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.12
        }} className="bg-white rounded-3xl overflow-hidden shadow-md hover:shadow-xl hover:-translate-y-2 transition-all duration-300 flex flex-col border border-[#F9A8B7]/20" data-id="element-25">
              <div className="relative aspect-[4/3] md:aspect-square bg-[#FFF8F0] overflow-hidden" data-id="element-26">
                <img src={bonus.image} alt={`Bono ${bonus.number} - ${bonus.title}`} loading="lazy" className="w-full h-full object-cover" data-id="element-27" />
                <div className="absolute top-3 left-3 bg-[#F9A8B7] text-white text-xs md:text-sm font-bold px-3 py-1 rounded-full shadow-md" data-id="element-28">
                  🎁 BONO {bonus.number}
                </div>
              </div>
              <div className="p-5 md:p-6 flex flex-col flex-grow" data-id="element-29">
                <p className="text-[10px] md:text-xs font-bold text-[#A9D7E2] tracking-widest uppercase mb-1.5 md:mb-2" data-id="element-30">
                  Bono {bonus.number}
                </p>
                <h3 className="text-base md:text-xl font-bold text-[#2D1F1A] mb-2 md:mb-3 leading-tight" data-id="element-31">
                  {bonus.title}
                </h3>
                <p className="text-sm md:text-base text-gray-600 leading-relaxed mb-4 md:mb-5 flex-grow" data-id="element-32">
                  {bonus.desc}
                </p>
                <div className="flex items-center gap-2 md:gap-3 pt-3 md:pt-4 border-t border-[#F9A8B7]/20" data-id="element-33">
                  <span className="text-gray-400 line-through font-medium text-base md:text-lg" data-id="element-34">
                    {bonus.value}
                  </span>
                  <span className="text-[#F9A8B7] font-bold text-base md:text-lg" data-id="element-35">
                    —
                  </span>
                  <span className="text-[#F9A8B7] font-bold text-lg md:text-xl tracking-wide underline decoration-2 underline-offset-4" data-id="element-36">
                    ¡GRATIS!
                  </span>
                </div>
              </div>
            </motion.div>)}
        </div>
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="mt-8 md:mt-12 text-center bg-white rounded-2xl p-5 md:p-8 shadow-md border-2 border-dashed border-[#F9A8B7]/40" data-id="element-37">
          <p className="text-lg md:text-2xl font-bold text-[#2D1F1A] leading-snug" data-id="element-38">
            👉 Valor total de los bonus:{' '}
            <span className="line-through text-gray-400 font-medium" data-id="element-39">
              $84.97
            </span>
            <span className="text-[#F9A8B7]" data-id="element-40">
              {' '}
              — ¡GRATIS hoy con la compra!
            </span>
          </p>
        </motion.div>
      </div>
    </section>;
}